module.exports = __webpack_public_path__ + "img/00.1cb4e72b.png";